import {
  FormControl,
  SearchPickerInput,
  useSearchPicker,
  FormErrorMessage,
} from '@wegroup/design-system';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { FormOption } from '../../../../../../../../types/Form';
import { Option } from '../../../../../../../design-system/src/content/components/SearchPickerInput';
import { prefilledInputComponentStyling } from '../../../../../constants/InputComponentStyling';
import useFlowInputComponent from '../../../../../hooks/useFlowsInputComponent';
import { FlowsQuestion } from '../../../../../types/FlowsTypes';
import useEnumOptions from '../hooks/useEnumOptions';

interface Props {
  question: FlowsQuestion;
}

const IndexMultiselectInputComponent: React.FC<
  React.PropsWithChildren<Props>
> = ({ question }) => {
  const { t } = useTranslation();
  const {
    field: { value, onBlur },
    error,
    prefilled,
  } = useFlowInputComponent({ question });

  const chosenValues = (value as number[] | undefined) || [];

  const enumOptions: FormOption[] = useEnumOptions(question);

  const options = useCallback(
    (val: string): Option[] => {
      return enumOptions.filter((o) =>
        o.label.toLowerCase().includes(val.toLowerCase()),
      );
    },
    [enumOptions],
  );

  const { componentProps } = useSearchPicker({
    searchFunction: options,
  });

  const handleOnBlur = (options: Option[]) => {
    onBlur({
      name: question.id,
      value: options.map(({ value }) => parseInt(value)),
    });
  };

  return (
    <FormControl isInvalid={!!error}>
      <SearchPickerInput
        {...componentProps}
        isDisabled={question.rules.is_disabled}
        selectedOptions={enumOptions.filter(({ value: _value }) =>
          chosenValues.includes(parseInt(_value)),
        )}
        setSelectedOptions={handleOnBlur}
        boxShadow="base"
        border="1px"
        borderColor="gray.50"
        hideIcons
        placeholder={t('DEFAULT_MULTISELECT_OPTIES')}
        {...(prefilled && {
          sx: {
            ...prefilledInputComponentStyling,
            input: {
              bg: '#FFF9EA',
            },
          },
        })}
        withSelectAll
      />
      <FormErrorMessage justifyContent="flex-end">
        {error?.message}
      </FormErrorMessage>
    </FormControl>
  );
};

export default IndexMultiselectInputComponent;
